import { useEffect, useState } from "react";

const INTERACTION_EVENTS: (keyof WindowEventMap)[] = [
  "pointerdown",
  "keydown",
  "scroll",
  "touchstart",
];

export function useIdleMount(timeout = 6000): boolean {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (ready) return;

    let started = false;
    const start = () => {
      if (started) return;
      started = true;
      INTERACTION_EVENTS.forEach((evt) =>
        window.removeEventListener(evt, start),
      );
      clearTimeout(fallbackId);
      setReady(true);
    };

    INTERACTION_EVENTS.forEach((evt) =>
      window.addEventListener(evt, start, { once: true, passive: true }),
    );
    const fallbackId = setTimeout(start, timeout);

    return () => {
      INTERACTION_EVENTS.forEach((evt) =>
        window.removeEventListener(evt, start),
      );
      clearTimeout(fallbackId);
    };
  }, [ready, timeout]);

  return ready;
}
